import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { asyncScheduler, Observable, observeOn } from 'rxjs';
import { PageTitleService } from '../service/page.title.service';

@Component({
  selector: '[app-page-title]',
  template: '<span id="pageTitle">{{ title$ | async }}</span>',
  standalone: true,
  imports: [AsyncPipe],
})
export class PageTitleComponent {
  readonly title$: Observable<string>;

  constructor(pageTitleService: PageTitleService) {
    this.title$ = pageTitleService.pageTitle.pipe(observeOn(asyncScheduler));
  }
}
